module.exports = __webpack_public_path__ + "img/p.1014afe8.png";